<div class="d-flex justify-content-between">
  <div class="profile-picture-panel">
    <app-profile-picture />
  </div>
  <div class="profile-data d-none d-sm-block pl-3 font-size-primary">
    <div class="d-flex row pb-3">
      <div class="col-sm-3">{{ "public.profile.name" | translate }}</div>
      <div class="col-sm-9">{{ name }}</div>
    </div>
    <div class="d-flex row pb-3">
      <div class="col-sm-3">{{ "public.profile.phone" | translate}}</div>
      <div class="col-sm-9">{{ phone }}</div>
    </div>
    <div class="d-flex row pb-3">
      <div class="col-sm-3">{{ "public.profile.email" | translate}}</div>
      <div class="col-sm-9">{{ email }}</div>
    </div>
  </div>
  <div>
    <app-button startIcon="fa-pencil" (click)="onEditProfile()">
      <span class="ml-2 d-none d-sm-inline-block">{{ "public.profile.edit" |translate }}</span>
    </app-button>
  </div>
</div>
<div class="row mt-3">
  <div class="profile-data d-sm-none d-block pl-3 font-size-primary">
    <div class="d-flex row pb-3">
      <div class="col-3">{{ "public.profile.name" | translate }}</div>
      <div class="col-9">{{ name }}</div>
    </div>
    <div class="d-flex row pb-3">
      <div class="col-3">{{ "public.profile.phone" | translate}}</div>
      <div class="col-9">{{ phone }}</div>
    </div>
    <div class="d-flex row pb-3">
      <div class="col-3">{{ "public.profile.email" | translate}}</div>
      <div class="col-9">{{ email }}</div>
    </div>
  </div>
</div>